module.exports = __webpack_public_path__ + "img/donut.be5030ca.webp";